import React from 'react';


const Preloader = ({ message = "Loading..." }) => {
    return (
        <div className="preloader-container">
            <div className="preloader-content">
                {/* Main spinner */}
                <div style={{ height: "80px", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "30px" }}>
                    <div className="admin-loader"></div>
                </div>

                {/* Loading text with animated dots */}
                <div className="loading-text">
                    <span>{message}</span>
                    <span className="dots">
                        <span className="dot dot1">.</span>
                        <span className="dot dot2">.</span>
                        <span className="dot dot3">.</span>
                    </span>
                </div>

                {/* Progress bar */}
                <div className="progress-bar">
                    <div className="progress-fill"></div>
                </div>
            </div>
        </div>
    );
};

export default Preloader;